import * as hippoConstFactory from 'common/hippoConst.js';

export const paymentMethodDisplayName = {
    escrow: 'mortgage bill',
    cc: 'credit card',
    ach: 'bank account (ACH)'
};

const HIPPO_CONSTS = hippoConstFactory();

const SUPPORT_NUMBER = HIPPO_CONSTS.HIPPO_SUPPORT_PHONE_NUMBER;

export const ADDITIONAL_INFORMATION_MAP = {
    PAID: 'Everything looks good - you are all paid up.',
    NOT_RECEIVED_POLICY_CANCELLED: {
        ESCROW:
            "Your policy was cancelled because we didn't receive your escrow payment. We can remedy this. " +
            `To reinstate your policy, please call us at ${SUPPORT_NUMBER}.`,
        ACH_OR_CC:
            "Your policy was cancelled because we didn't receive payment. We can remedy this. " +
            `To reinstate your policy, please call us at ${SUPPORT_NUMBER}.`
    },
    PENDING: {
        ESCROW: {
            UP_TO_20_DAYS_AFTER_EFFECTIVE_DATE: (dueDate: string) =>
                `We're waiting for payment from your escrow account, which is due on ${dueDate}.<br> ` +
                `<span class="additional-info-text-bold">Nothing to worry about.</span>`,
            BETWEEN_20_AND_30_DAYS_AFTER_EFFECTIVE_DATE: (dueDate: string) =>
                `We haven't received payment from your escrow account, which is due on ${dueDate}. ` +
                `To make sure it's paid on time, please contact your escrow company or call us at ${SUPPORT_NUMBER}.`
        },
        ACH: (paymentDate: string) => `We will charge your bank account on ${paymentDate}. Nothing else is needed.`,
        CC: (paymentDate: string) => `We will charge your credit card on ${paymentDate}. Nothing else is needed.`
    },
    NOT_RECEIVED: {
        ESCROW: (dueDate: string) =>
            `Your policy will be cancelled on ${dueDate} if payment isn't received. ` +
            `Please call us at ${SUPPORT_NUMBER} so we can take steps to keep your policy intact.`,
        ACH: `You have outstanding payment past due.  Please pay now by clicking below.`
    },
    PENDING_TERMINATE_OTHER: 'Based on the cancellation date of your policy, you may be receiving a prorated refund.',
    NON_PAYMENT_PENDING_TERMINATE_LAST_CHARGE_DID_NOT_FAIL: {
        CC:
            'Thank you for your payment. Your policy should be reinstated within the next business day. ' +
            `Otherwise please call us at ${SUPPORT_NUMBER}.`,
        ACH:
            'Thank you for your payment. Your policy should be reinstated within the next 5 business days. ' +
            `Otherwise please call us at ${SUPPORT_NUMBER}.`
    },
    DUE: (outstandingBalance: string) =>
        `You have an outstanding balance of ${outstandingBalance}. To keep your policy active, please make your payment ` +
        `by clicking below.`,
    FAILED: {
        CC:
            `We tried charging your credit card and weren't successful. Please take a moment to ` +
            "update your card's information. We'll try again tomorrow."
    },
    FAILED_PENDING_TERMINATE: {
        CC:
            'We tried charging your credit card several times and have not been successful. ' +
            "To prevent your policy from being cancelled, please update your card's information and pay now.",
        ACH:
            "We tried debiting your bank account and weren't successful. " +
            "Please take a moment to update your account's information. We'll try again tomorrow."
    },
    OUTSTANDING: (outstandingBalance: string) =>
        `Based on the cancellation date of your policy, there is an outstanding balance of ${outstandingBalance}. ` +
        `Please make your payment by clicking below.`,
    UPCOMING_PAYMENT: {
        CC: (paymentDate: string, paymentAmount: string) =>
            `You have an upcoming payment on ${paymentDate} for ${paymentAmount}. ` +
            `You will be charged automatically or you can pay now by clicking below.`,
        ACH: (paymentDate: string, paymentAmount: string) =>
            `You have an upcoming payment on ${paymentDate} for ${paymentAmount}. ` +
            `Your bank account will be debited automatically or you can pay now by clicking below.`
    },
    CANCELLED: "Your policy is cancelled. We're sorry to lose you as a member of the Hippo family.",
    CC_PAYMENTS_REQUIRED: 'You have outstanding payment past due.  Please take a moment and pay now by clicking below.',
    DELAYED: (paymentAmount: string) =>
        'You will be charged automatically, or you can make a one time payment for the amount of ' +
        `${paymentAmount} by clicking below.`
};

export enum CUSTOMER_PAYMENT_STATUS {
    PENDING = 'pending',
    PAID = 'paid',
    DUE = 'due',
    NOT_RECEIVED = 'not_received',
    NOT_RECEIVED_POLICY_CANCELLED = 'not_received_policy_cancelled',
    FAILED = 'failed',
    OUTSTANDING = 'outstanding',
    CANCELLED = 'cancelled',
    DELAYED = 'delayed',
    CC_PAYMENTS_REQUIRED = 'cc_payments_required'
}

export const pendingEscrowTooltipContent =
    'It can take up to 30 days from the effective date of your policy to ' +
    'receive and process payment from your escrow account. We will send you email reminders if the payment has not ' +
    'been received at least 10 days prior to the due date';
